import { useMutation, useQuery, type UseQueryResult } from '@tanstack/react-query';

import { TEAM_SUMMARY_QUERY_KEYS } from './keys';

import * as teamSummaryService from 'services/teamSummary';
import * as appraiserChangeRequestService from 'services/appraiserChangeRequest';

import { handleError } from 'utils/errorHandler';

import type { ServiceId, ServiceParams } from 'interface/service';

export const getTeamSummaryQueryKey = (params: ServiceParams = {}) =>
  [TEAM_SUMMARY_QUERY_KEYS.SUMMARY, params] as const;

export const useFetchTeamSummaryQuery = <TData = unknown>(
  params: ServiceParams = {},
  enabled = true
): UseQueryResult<TData, Error> => {
  return useQuery({
    queryKey: getTeamSummaryQueryKey(params),
    queryFn: () => teamSummaryService.fetchTeamSummary(params) as Promise<TData>,
    enabled,
  });
};

export const useCreateAppraiserChangeRequestMutation = () => {
  return useMutation({
    mutationFn: ({ allocationId, reason }: { allocationId: ServiceId; reason: string }) =>
      appraiserChangeRequestService.create(allocationId, reason),
    onError: (error) => handleError(error),
  });
};
